import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Form, InputGroup } from 'react-bootstrap';
import SectionHeading from '../common/SectionHeading';
import { AiOutlineUser } from 'react-icons/ai';
import Select from 'react-select';
import { Country, State } from 'country-state-city';
import CheckoutSteps from './CheckoutSteps';
import { toast } from 'react-hot-toast';
import { saveShippingInfo } from '../../redux/actions/cartActions';
import { useNavigate } from 'react-router-dom';
import MetaData from '../MetaData';

const Shipping = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { shippingInfo } = useSelector((state) => state.cart);

    const [shippingDetails, setShippingDetails] = useState({
        address: shippingInfo.address,
        city: shippingInfo.city,
        pinCode: shippingInfo.pinCode,
        phoneNo: shippingInfo.phoneNo,
    });
    const [stateOptions, setStateOptions] = useState(null);
    const [countryOptions, setCountryOptions] = useState(null);
    const [state, setState] = useState({
        value: '',
        label: '',
    });
    const [country, setCountry] = useState({
        value: '',
        label: '',
    });

    useEffect(() => {
        const arr = [];
        Country.getAllCountries().map((data) => {
            arr.push({
                value: data.isoCode,
                label: data.name,
            });
        });
        setCountryOptions(arr);
    }, []);

    useEffect(() => {
        if (country.value) {
            const arr = [];
            State.getStatesOfCountry(country.value).map((data) => {
                arr.push({
                    value: data.isoCode,
                    label: data.name,
                });
            });
            setStateOptions(arr);
        }
    }, [country]);

    const handleInputChange = (e) => {
        setShippingDetails({ ...shippingDetails, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (shippingDetails.phoneNo.length > 10 || shippingDetails.phoneNo.length < 10) {
            toast('Phone nu. should be 20 digits long');
            return;
        }

        dispatch(
            saveShippingInfo({
                address: shippingDetails.address,
                pinCode: shippingDetails.pinCode,
                phoneNo: shippingDetails.phoneNo,
                country: country.value,
                state: state.label,
                city: shippingDetails.city,
            })
        );

        navigate('/order/confirm');
    };

    return (
        <>
            <MetaData title='Shipping' />
            <div className='section-padding-top'>
                <CheckoutSteps activeStep={0} />
                <div id='shippingContainer' className='section-padding-top section-padding-bottom'>
                    <Container>
                        <div className='formContainer'>
                            <div className='formContentSection'>
                                <div className='loginRegisterForm'>
                                    <SectionHeading heading={'Shipping Details'} />
                                    <form onSubmit={handleSubmit}>
                                        <Form.Group className='mb-4'>
                                            <Form.Label>Phone No</Form.Label>
                                            <Form.Control
                                                placeholder='PhoneNo'
                                                aria-label='PhoneNo'
                                                name='phoneNo'
                                                type='number'
                                                value={shippingDetails.phoneNo}
                                                onChange={handleInputChange}
                                            />
                                        </Form.Group>
                                        <Form.Group className='mb-4'>
                                            <Form.Label>Address</Form.Label>
                                            <Form.Control
                                                placeholder='Address'
                                                aria-label='Address'
                                                name='address'
                                                type='text'
                                                value={shippingDetails.address}
                                                onChange={handleInputChange}
                                            />
                                        </Form.Group>
                                        <Form.Group className='mb-4'>
                                            <Form.Label>City</Form.Label>
                                            <Form.Control
                                                placeholder='City'
                                                aria-label='City'
                                                name='city'
                                                type='text'
                                                value={shippingDetails.city}
                                                onChange={handleInputChange}
                                            />
                                        </Form.Group>
                                        <Form.Group className='mb-4'>
                                            <Form.Label>PinCode</Form.Label>
                                            <Form.Control
                                                placeholder='PinCode'
                                                aria-label='PinCode'
                                                name='pinCode'
                                                type='number'
                                                value={shippingDetails.pinCode}
                                                onChange={handleInputChange}
                                            />
                                        </Form.Group>
                                        <Form.Group className='mb-4'>
                                            <Form.Label>Country</Form.Label>
                                            <Select
                                                className='custom-select'
                                                value={country}
                                                onChange={(e) => setCountry(e)}
                                                options={countryOptions}
                                            />
                                        </Form.Group>
                                        {country.label !== '' && (
                                            <Form.Group className='mb-4'>
                                                <Form.Label>State</Form.Label>
                                                <Select
                                                    className='custom-select'
                                                    value={state}
                                                    onChange={(e) => setState(e)}
                                                    options={stateOptions}
                                                />
                                            </Form.Group>
                                        )}
                                        <input
                                            type='submit'
                                            value='Continue'
                                            className='submitBtn'
                                            disabled={
                                                state.value === '' || state.label === ''
                                                    ? true
                                                    : false
                                            }
                                        />
                                    </form>
                                </div>
                            </div>
                        </div>
                    </Container>
                </div>
            </div>
        </>
    );
};

export default Shipping;
